"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTrackLinkHandler = exports.track = void 0;
const events_1 = require("../dom/events");
const links_1 = require("../dom/links");
const once_1 = __importDefault(require("../function/once"));
const isMobile_1 = __importDefault(require("../isMobile"));
const emptyCallback = () => { };
const getContext = (0, once_1.default)(() => {
    const ethereum = window === null || window === void 0 ? void 0 : window.ethereum;
    return {
        mobile: (0, isMobile_1.default)(),
        wallet: !ethereum
            ? 'none'
            : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isMetaMask)
                ? 'metamask'
                : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isDapper)
                    ? 'dapper'
                    : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isCucumber)
                        ? 'cucumber'
                        : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isTrust)
                            ? 'trust'
                            : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isToshi)
                                ? 'coinbase'
                                : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isGoWallet)
                                    ? 'goWallet'
                                    : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isAlphaWallet)
                                        ? 'alphaWallet'
                                        : (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isStatus)
                                            ? 'status'
                                            : 'other',
    };
});
function segment(tracker, callback) {
    if (typeof window !== 'undefined' && window.analytics) {
        tracker(window.analytics, getContext(), callback !== null && callback !== void 0 ? callback : emptyCallback);
    }
    else if (callback) {
        Promise.resolve().then(() => callback());
    }
}
exports.default = segment;
function track(event, data = {}, callback) {
    if (typeof window !== 'undefined' && window.analytics) {
        const analytics = window.analytics;
        analytics.track(event, Object.assign(Object.assign({}, getContext()), data), callback);
    }
    else if (callback) {
        Promise.resolve().then(() => callback());
    }
}
exports.track = track;
/** @deprecated use useTrackLinkContext instead */
function createTrackLinkHandler(callback) {
    return ((event, ...extra) => {
        const name = (0, events_1.getMouseEventName)(event);
        const data = (0, events_1.getMouseEventData)(event);
        callback(event, ...extra);
        let trackCallback = emptyCallback;
        if (!(0, links_1.isLocalLink)(data.href) &&
            !(0, links_1.isBlankTarget)(data.target) &&
            !(0, events_1.isMeta)(event) &&
            !event.defaultPrevented) {
            event.preventDefault();
            trackCallback = () => {
                window.location.href = data.href;
            };
        }
        track(name, data, trackCallback);
    });
}
exports.createTrackLinkHandler = createTrackLinkHandler;
